const dashboard = {
  totalPatients: 'Total Patients',
  New: 'New Patients',
  criticalPatients: 'Critical Patients',
  abnormalPatients: 'Abnormal Patients',
  activePatients: 'Active Patients',
  Escalation: 'Escalation',
  Moderate: 'Moderate',

  WNL: 'WNL',
  Watchlist: 'Watchlist',
  Trending: 'Trending',
  Message: 'Message',
  inactivePatients: 'Inactive Patients',
  careCoordinatorStats: 'Care Coordinator Stats',
  cPTCodeBillingSummary: 'CPT Code Billing Summary',
  financialStats: 'Financial Stats',
  totalPatientsChart: 'Total Patients Chart',
  appointmentSummary: 'Appointments Summary',
  Normal: 'Normal',
  High: 'High',
  Critical: 'Critical',
  newPatientsChart:'New Patients Chart',
  Other:'Other',
  Communication:"Communication"
  
}


export default dashboard
